import { useEffect, useState } from "react";
import { IconBell } from "@tabler/icons";
import "../../static/css/floating-bell.css";

export const FloatingNotificationBell = ({
  isVisible,
  title,
  body,
  variant = "success",
  onClick,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const isSuccess = variant === "success";

  useEffect(() => {
    if (isVisible) {
      setIsAnimating(true);
    }
  }, [isVisible, title, body]);

  if (!isVisible) {
    return null;
  }

  const buttonClass = isSuccess
    ? "floating-bell-button floating-bell-button--success floating-bell-hover floating-bell-hover--success floating-bell-active"
    : "floating-bell-button floating-bell-button--danger floating-bell-hover floating-bell-hover--danger floating-bell-active";

  const pulseClass = isSuccess
    ? "floating-bell-pulse-ring floating-bell-pulse-ring--success"
    : "floating-bell-pulse-ring floating-bell-pulse-ring--danger";

  const dotClass = isSuccess
    ? "floating-bell-badge-dot floating-bell-badge-dot--success"
    : "floating-bell-badge-dot floating-bell-badge-dot--danger";

  return (
    <div className="floating-bell-container">
      <div className="floating-bell-tooltip">
        <div className="floating-bell-tooltip-title">
          {title || "New Notification"}
        </div>
        <div className="floating-bell-tooltip-body">
          {body || "You have a new update"}
        </div>
      </div>

      <button
        type="button"
        className={`${buttonClass} ${isAnimating ? "floating-bell-vibrate floating-bell-bounce" : ""}`}
        onClick={onClick}
        aria-label="Appointment notification">
        <IconBell size={28} color="#fff" />

        {isAnimating && (
          <>
            <span className={`${pulseClass} floating-bell-pulse`} />
            <span
              className={`${pulseClass} floating-bell-pulse animation-delay-200`}
            />
          </>
        )}

        <span className="floating-bell-badge">
          <span
            className={`${dotClass} ${!isAnimating ? "notification-dot" : ""}`}
          />
        </span>
      </button>
    </div>
  );
};
